import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AnalyticsConstants from '@bibliocommons/constants-analytics';

import AnalyticsActions from 'app/actions/AnalyticsActions';
import { bibContextShape } from 'app/shapes/analytics';
import AnalyticsContext from './AnalyticsContext';

export class AnalyticsContextContainer extends React.PureComponent {
  render() {
    return <AnalyticsContext {...this.props} />;
  }
}

AnalyticsContextContainer.propTypes = {
  analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  context: bibContextShape.isRequired,
  contextName: PropTypes.oneOf([AnalyticsConstants.CONTEXTS.BIB]).isRequired
};

const mapDispatchToProps = dispatch => ({
  analyticsActions: bindActionCreators(AnalyticsActions, dispatch)
});

export default connect(null, mapDispatchToProps)(AnalyticsContextContainer);
